import React, { Component } from 'react'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { EditableReactSelect, EditableTextField } from '../common/EditableComponents'

const getFilterOptions = [
  { label: 'BLAZE', value: 'BLAZE' },
  { label: 'springbig', value: 'springbig' },
]

class SpringbigModalSyncMembers extends Component {
  constructor(props) {
    super(props)

    this.state = {
      textOptIn: false,
      emailOptIn: false,
      fields: {},
    }
  }

  handleChangeFields = (name) => (event) => {
    this.setState({ [name]: event.target.checked })
    this.setState({ fields: { ...this.state.fields, [name]: event.target.checked } })
  }

  handleChangeSourceOfTrue = (state) => {
    let value = state && state.value
    this.setState({
      source: value,
    })
  }

  render() {
    const { open, close } = this.props
    const { fields, source } = this.state

    return (
      <Dialog open={open} className={'container-small-modal'}>
        <DialogTitle>Sync Members</DialogTitle>
        <DialogContent className={'size-small-modal'}>
          <span>
            You can safely sync your members between BLAZE and springbig. Select the source of truth
            and which fields to sync.
          </span>
          <p></p>
          <EditableReactSelect
            className=""
            name="sourceoftruth"
            placeholder="Source of truth"
            options={getFilterOptions}
            valueToRender={getFilterOptions.map((option) => option.value).join(', ')}
            value={source}
            onChange={this.handleChangeSourceOfTrue}
            type="text"
            InputLabelProps={{
              shrink: true,
            }}
            editMode
          />
          <p></p>
          <span>Please check the desired field(s) to sync:</span>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.checkedA}
                  onChange={this.handleChangeFields('textOptIn')}
                  value="textOptIn"
                />
              }
              label="SMS Opt-In"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.checkedB}
                  onChange={this.handleChangeFields('emailOptIn')}
                  value="emailOptIn"
                  color="primary"
                />
              }
              label="Email Opt-In"
            />
          </FormGroup>
        </DialogContent>
        <DialogActions className="container-buttons-adoption-mode">
          <Button onClick={close} className="button-white-and-red">
            <span className="button-text">Cancel</span>
          </Button>
          <Button
            onClick={() => this.props.startSync(source, fields)}
            className="button-blue-and-white"
          >
            <span className="button-text">Start Sync</span>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default SpringbigModalSyncMembers



// WEBPACK FOOTER //
// ./src/components/Springbig/SpringbigModalSyncMembers.js